import { Tooltip } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { FunctionComponent, HTMLAttributes } from 'react';

import { TemplateTranslation } from 'apis/templates';
import supportedLanguages from 'app/utils/supportedLanguages';

import styles from './templateLanguagesCell.module.scss';

interface PropsT extends HTMLAttributes<HTMLDivElement> {
  translations: TemplateTranslation[] | null;
  languagesClassName?: string;
  countClassName?: string;
}

export const TemplateLanguagesCell: FunctionComponent<PropsT> = ({
  translations,
  className,
  ...restProps
}) => {
  const locales = Object.keys(translations || {});

  if (!locales.length) {
    return null;
  }

  const languages = supportedLanguages
    .filter((language) => locales.includes(language.code))
    .map((language) => language.label);

  const languagesString = languages.join(', ');

  const rootClass = classnames(styles.root, className);

  return (
    <Tooltip content={languagesString}>
      <div className={rootClass} {...restProps}>
        <div className={styles.languages}>{languagesString}</div>
        <div className={styles.total}>({locales.length})</div>
      </div>
    </Tooltip>
  );
};
